import { render, staticRenderFns } from "./LegacyBulkProductInformation.vue?vue&type=template&id=d105b464&"
import script from "./LegacyBulkProductInformation.vue?vue&type=script&lang=js&"
export * from "./LegacyBulkProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./LegacyBulkProductInformation.vue?vue&type=style&index=0&id=d105b464&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports